import React from 'react';
interface TextFieldProps {
  label: string;
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
}
export function TextField({
  label,
  value,
  placeholder,
  onChange
}: TextFieldProps) {
  const id = React.useId();
  return <div className="flex items-center justify-between gap-4" data-id="element-134" data-mp="1pa5x4tbph9xe">
      <label htmlFor={id} className="text-sm text-paper-muted" data-id="element-135" data-mp="1u40lia29ad2t">
        {label}
      </label>
      <input id={id} type="text" value={value} placeholder={placeholder} onChange={e => onChange(e.target.value)} className="w-32 shrink-0 rounded-lg border border-line bg-ink-950 px-3 py-2 text-right text-sm text-paper outline-none placeholder:text-paper-dim focus:border-paper-dim" data-id="element-136" data-mp="1y3ixuhg0hfu1" />
    </div>;
}